import './changePw.less';

import {
    sendApiRequest,
    // globalErrorHandler,
    // getManagersMenu
} from '../../js/api';

import {dialogBox} from '../dialogBox/dialogBox';

// import {showFeedbackMsg} from '../../js/helper/feedbackMsg';

export class changePassword {

    constructor(instanceName, custom = null){

        // 呼叫時用來儲存實體的 window 變數名稱 (window.changePwBox)
        // 在關閉後要清空此變數
        this.instanceName = instanceName;

        // 客製化設定
        this.custom = custom;

        this.box = null;
        this.boxId = 'changePwBox';
        // this.box = new dialogBox(this.boxId, false, false);
        if(custom){
            // 顯示提示文字區塊
            this.box = new dialogBox(this.boxId, true, false, 'fullwidth');
        } else {
            // 不需要提示文字區塊
            this.box = new dialogBox(this.boxId, false, false);
        }

        this.container = this.box.container;

        if(custom?.forceOpen === true){
            this.container.classList.add('forceOpen');
        }

        this.inputData = {};

        // input 時檢查輸入的新密碼是否一致
        // this.mismatch = true;

        this.uiText = window.t('changePassword');

        this.init();
    }

    init(){

        this.setContent();

        this.events();

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.box.open();
            });
        });

        // setTimeout(() => {
        //     this.box.open();
        // }, 0);

        // this.box.open();

    }

    setContent(){
        try {
            // 設定標題
            const uiText = this.uiText;

            this.box.set_title(uiText.title);

            // 眼睛按鈕
            function toggle(targetId){
                const Html =
                `<div class="visibility-toggle" data-for="${targetId}">
                    <svg class="show">
                        <use xlink:href="/assets/sprites/sprites_solid.svg#eye"></use>
                    </svg>
                    <svg class="hide">
                        <use xlink:href="/assets/sprites/sprites_solid.svg#eye-slash"></use>
                    </svg>
                </div>`;
                return Html;
            }

            let logOutHint = '';
            let patternText = '';

            // tcat 資訊安全規範
            if(this.custom?.type === 'tcatForceChange'){

                if(this.custom.lastUpdated && this.custom.diffDay){
                    const lastUpdated = this.custom.lastUpdated.format('YYYY/MM/DD');
                    const diffDay = this.custom.diffDay;

                    const hint =
                    `<p class="${this.custom.type}">根據統一速達資訊安全規範，每<strong>60天</strong>需變更一次密碼才能繼續使用。<br />上次密碼變更：${lastUpdated} (${diffDay} 天前)</p>`;

                    const text =
                    `<ul class="${this.custom.type}">
                        <li>根據統一速達資訊安全規範，每<strong>60 天</strong>必需變更一次密碼才能繼續使用</li>
                        <li>上次變更：${lastUpdated} (${diffDay} 天前)</li>
                    </ul>`;

                    this.box.set_hint(text);
                } else {
                    this.container.querySelector('.hint').remove();
                }

                patternText = '<small>至少 10 個字以上，需同時包含英文與數字</small>';

                // 強制改密碼時，為了避免使用者忘記舊密碼卡住
                // 所以需要提供登出按鈕，登出後再使用忘記密碼功能
                if(this.custom?.forceOpen === true){

                    logOutHint = '<small>如果忘記舊密碼，請先登出後再選擇「忘記密碼？」</small>';

                    const buttons =
                    `<div class="btn cancel" id="${this.custom.type}Logout">
                        <svg><use xlink:="" href="/assets/sprites/sprites_solid.svg#times"></use></svg>${window.t('common.button.logOut')}
                    </div>
                    <div class="btn confirm" id="${this.boxId}confirm">
                        <svg><use xlink:="" href="/assets/sprites/sprites_solid.svg#check"></use></svg>${window.t('common.button.confirm')}
                    </div>`;

                    this.box.set_btnwpr(buttons);
                }

            }

            const content =
            `<div class="inputwpr">
                <label>${uiText.label.current}${logOutHint}</label>
                <div class="inputbox">
                    <input id="CPcurrent" type="password" required autocomplete="new-password" name="current_password" />
                    ${toggle('CPcurrent')}
                </div>
            </div>
            <div class="inputwpr">
                <label>${uiText.label.new}${patternText}</label>
                <div class="inputbox">
                    <input id="CPnew" type="password" required autocomplete="new-password" name="password" />
                    ${toggle('CPnew')}
                </div>
            </div>
            <div class="inputwpr">
                <label>${uiText.label.confirm}${patternText}</label>
                <div class="inputbox">
                    <input id="CPconfirm" type="password" required autocomplete="new-password" name="password_confirmation" />
                    ${toggle('CPconfirm')}
                </div>
            </div>
            <div id="CPErrMsg"></div>
            <div id="CPsuccess"></div>`;

            this.box.set_content(content);

        } catch(error){
            console.log(error);
            this.destroy();
        }
    }

    // ----- 關閉後清除對話框 ----- //
    destroy(){

        this.box.close();

        setTimeout(() => {
            // 關閉之後清空建立的 instance
            window[this.instanceName] = null;

            // 清除 DOM
            try {
                this.container.parentNode.removeChild(this.container);
            } catch(error){
                console.log(error);
            }
        },500);
    }

    // ----- 切換密碼顯示 ----- //
    toggleVisibility(thisDom, inputId){
        try {
            const input = this.container.querySelector(`#${inputId}`);

            if(thisDom.classList.contains('visible')){
                // input切換成 password
                input.type = 'password';
                thisDom.classList.remove('visible');
            } else {
                // input 切換成 text
                input.type = 'text';
                thisDom.classList.add('visible');
            }

        } catch(error){
            console.log(error);
        }
    }

    // ----- 顯示錯誤訊息 ----- //
    // 傳入 false 可以清空訊息
    showErrMessage(text){

        const CPErrMsg = this.container.querySelector('#CPErrMsg');

        if(text === false){
            CPErrMsg.innerHTML = '';
        } else {
            CPErrMsg.innerHTML = `<p>${text}</p>`;
        }
    }

    // ----- 顯示完成對話框 ----- //
    showSuccessMessage(custom = null){

        const wrapper = this.container.querySelector('#CPsuccess');

        const title = this.uiText.success.title;
        let msg = this.uiText.success.msg;

        let buttonText = window.t('common.button.close');
        let buttonId = `${this.boxId}complete`;

        if(custom === 'tcatForceChange'){
            msg = '請使用新密碼重新登入';
            buttonText = '重新登入';
            buttonId = `${custom}Complete`;
        }

        const Html =
        `<div class="innerwpr">
            <h3>${title}</h3>
            <p>${msg}</p>
            <div class="icon">
                <svg><use xlink:="" href="/assets/sprites/sprites_solid.svg#check"></use></svg>
            </div>

            <div class="btn confirm" id="${buttonId}">
                ${buttonText}
            </div>
        </div>`;

        wrapper.innerHTML = Html;

        setTimeout(() => {
            this.container.classList.add('success');
        }, 100);
    }

    // ----- 送出請求 ----- //
    async sendRequest(){

        // 輸入的資料不完整
        if(
            !Object.hasOwn(this.inputData, 'current_password') ||
            !Object.hasOwn(this.inputData, 'password') ||
            !Object.hasOwn(this.inputData, 'password_confirmation')
        ){
            this.showErrMessage(window.t('common.hint.inputIncomplete'));
            return;
        } else {
            this.showErrMessage(false);
        }

        const pw0 = this.inputData.current_password;
        const pw1 = this.inputData.password;
        const pw2 = this.inputData.password_confirmation;

        // 新密碼不可與舊密碼相同
        if(pw0 === pw1){
            this.showErrMessage(this.uiText.msg.mustDifferent);
            return;
        } else {
            this.showErrMessage(false);
        }

        // 輸入的新密碼不一致
        if(pw1 !== pw2){
            this.showErrMessage(this.uiText.msg.mismatch);
            return;
        } else {
            this.showErrMessage(false);
        }

        // tcat 資訊安全規範
        if(this.custom?.type === 'tcatForceChange'){
            // 至少出現一個英文字母
            // 至少出現一個數字
            // 任意字元（包含符號）至少 10 個 (允許空白字元)
            const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d).{10,}$/;

            if(!PASSWORD_REGEX.test(pw1)){
                this.showErrMessage(this.uiText.msg.notRequirements);
                return;
            } else {
                this.showErrMessage(false);
            }
        }

        try {
            const payload = {...this.inputData};
            delete payload['password_confirmation'];

            document.body.classList.add('loading');

            let apiData = null;
            apiData = await sendApiRequest('put', '/password', payload)
                .then(res => res.data);

            const customType = this.custom?.type ?? null;
            // 顯示成功訊息對話框
            this.showSuccessMessage(customType);

        } catch(error){
            // 變更密碼失敗，請確認舊密碼是否正確
            this.showErrMessage(this.uiText.msg.failed);
        } finally {
            document.body.classList.remove('loading');
        }

    }

    // ----- 事件處理 ----- //
    events(){

        this.container.addEventListener('click', (event) => {

            // 關閉後清除對話框
            if(event.target.id === `${this.boxId}cancel` ||
               event.target.id === `${this.boxId}complete`){
                this.destroy();
            }

            if(event.target.id === `${this.boxId}confirm`){
                this.sendRequest();
            }

            // 切換密碼顯示
            if(event.target.classList.contains('visibility-toggle')){
                this.toggleVisibility(
                    event.target,
                    event.target.dataset.for
                );
            }

            // tcat 強制修改密碼，忘記舊密碼選擇登出
            const tcatForceChangeLogoutBtn = event.target.closest('#tcatForceChangeLogout');

            if(tcatForceChangeLogoutBtn){
                window.mainUser.logout(); // 登出
            }

            // tcat 強制修改密碼完成
            const tcatForceChangeCompleteBtn = event.target.closest('#tcatForceChangeComplete');

            if(tcatForceChangeCompleteBtn){
                window.mainUser.logout(); // 登出
            }
        });

        this.container.addEventListener('input', (event) => {

            if(event.target.tagName === 'INPUT'){

                const input = event.target;
                const value = input.value;

                if(value.length > 0){
                    this.inputData[input.name] = value;
                } else {
                    delete this.inputData[input.name];
                }

                // 「輸入新密碼」與「再次輸入新密碼」
                // 執行相同的檢查程序
                /*
                if(input.id === 'CPnew' || input.id === 'CPconfirm'){
                    try {
                        let password = '';
                        let passwordConfirmation = '';

                        if(input.id === 'CPnew'){
                            password = value;
                            passwordConfirmation = this.container.querySelector('#CPconfirm').value;
                        }

                        if(input.id === 'CPconfirm'){
                            password = this.container.querySelector('#CPnew').value;
                            passwordConfirmation = value;
                        }

                        if(password !== passwordConfirmation){
                            // 輸入的新密碼不一致
                            this.showErrMessage(this.uiText.msg.mismatch);
                            this.mismatch = true;
                        } else {
                            // 密碼一致，通過檢查
                            this.showErrMessage(false);
                            this.mismatch = false;
                        }
                    } catch(error){
                        console.log(error);
                    }
                }
                */
            }

        });

    }

}